import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import {
    DataGrid,
    GridColDef,
    GridToolbar,
    GridValueFormatterParams
} from "@mui/x-data-grid";
import { Box, Button, Dialog, DialogContent, TextField, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { getTreatments } from "../services/get.service";
import { treatment } from "../common/type";
import ClipLoader from "react-spinners/ClipLoader";
import { useForm } from "react-hook-form";
import { putTreatment } from "../services/put.service";
import { toast } from "react-toastify";

const Treatments = () => {
    const [loading, setLoading] = useState<boolean>(false)
    const [open, setOpen] = useState<boolean>(false)
    const [treatment, setTreatment] = useState<treatment>()
    const [rows, setRows] = useState<Array<treatment>>([])

    useEffect(() => {
        setLoading(true);

        getTreatments()
            .then((res) => {
                setLoading(false);
                setRows(res.data)
            })
            .catch((err) => {
                setLoading(false)
                console.log(err)
            })
    }, [setRows]);

    const { register, handleSubmit, reset } = useForm()

    const onSubmit = (data: any) => {
        var id = toast.loading("Please wait...", {
            theme: "colored",
            type: "info",
            closeButton: true,
        });

        putTreatment(data)
            .then(() => {
                toast.update(id, {
                    render: "Updated",
                    type: "success",
                    theme: "colored",
                    autoClose: 2500,
                    isLoading: false,
                    closeOnClick: true,
                    hideProgressBar: false,
                });
            })
            .catch((err) => {
                toast.update(id, {
                    render: err?.response?.data?.detail,
                    theme: "colored",
                    autoClose: 5000,
                    type: "error",
                    isLoading: false,
                    closeOnClick: true,
                    hideProgressBar: false,
                });
            })
    }

    const columns: GridColDef[] = [
        { field: 'name', headerName: "Name", width: 170 },
        // { field: 'minPrice', headerName: "Min Price", width: 170, type: "number" },
        { field: 'maxPrice', headerName: "Max Price", width: 170, type: "number" },
        {
            field: 'createdAt', headerName: "Created Date", width: 170, type: "datetime", valueFormatter: (val: GridValueFormatterParams<Date>) => {
                var date = new Date(val.value)
                return date.toLocaleDateString("en", {
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                })
            }
        },
        { field: 'ownerId', headerName: "Meleyo", width: 170 },
        // {
        //     field: 'ranges', headerName: "Ranges in %", width: 170, valueFormatter: (val: GridValueFormatterParams<range[]>) => {
        //         var ranges: string[] = []

        //         val.value?.map((range) => {
        //             // console.log(range.name + range.min + '~' + range.default + '~' + range.max);
        //             ranges.push(range.name + '-' + range.min + '~' + range.default + '~' + range.max)

        //             return range;
        //         })

        //         if (val.value === null)
        //             return "-"

        //         return ranges
        //     }
        // },
    ]

    return <>
        <Helmet>
            <title>Treatments</title>
        </Helmet>
        <div className="dark:text-black w-full">
            <div className="lg:m-12 m-4">
                <div className="bg-amber50 shadow-md rounded w-full px-3 lg:px-20 py-10 pt-5">
                    <Button variant="contained">
                        <Link to="/create/treatment">Add New</Link>
                    </Button>
                    <Typography variant="h4" fontSize={32} className="py-3">Treatments</Typography>
                    <Box sx={{ height: 520, width: "100%" }}>
                        {loading ?
                            (
                                <ClipLoader loading={loading} size={70} />
                            )
                            :
                            (
                                rows !== undefined && rows.length > 0 ?
                                    (
                                        <DataGrid rows={rows} onRowClick={(r) => { reset(); setOpen(true); setTreatment(rows.find((row) => row.id === r.id)) }}
                                            columns={columns} slots={{ toolbar: GridToolbar }} />
                                    )
                                    :
                                    <DataGrid rows={[]} columns={columns} />
                            )
                        }
                    </Box>
                </div>
            </div>
        </div>

        <Dialog open={open} onClose={() => setOpen(false)}>
            <DialogContent>
                <Typography align="center">Edit Treatment</Typography>
                <form className="py-3 grid gap-3" onSubmit={handleSubmit(onSubmit)}>
                    <input type="hidden" value={treatment?.id} {...register("id")} />
                    <TextField size="small" label="Max Price" {...register("maxPrice")} required type="number" placeholder="Max Price"
                        defaultValue={treatment?.maxPrice} inputProps={{ min: 1 }} />
                    <Button type="submit" variant="contained" onClick={() => setOpen(false)}>Edit</Button>
                </form>
            </DialogContent>
        </Dialog>
    </>;
};

export default Treatments;
